import { render, staticRenderFns } from "./TripRequests.vue?vue&type=template&id=a594b01e&scoped=true&"
import script from "./TripRequests.vue?vue&type=script&lang=js&"
export * from "./TripRequests.vue?vue&type=script&lang=js&"
import style0 from "./table-style.css?vue&type=style&index=0&id=a594b01e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a594b01e",
  null
  
)

export default component.exports